/** Daily cadence (spec change 2026-07-06) — measured from the later of last shown / last dismissed. */
export const WEB_NATIVE_APP_PROMO_COOLDOWN_HOURS = 24;

export const WEB_NATIVE_APP_PROMO_SHOW_DELAY_MS = 1500;

/**
 * The former `web_native_app_promo_shown_this_session` sessionStorage key is retired:
 * Android Chrome restores sessionStorage across tab restores, so "session" dedup
 * suppressed the promo indefinitely. Stale keys in the wild are ignored.
 */
export const WEB_NATIVE_APP_PROMO_STORAGE_KEYS = {
  PERMANENT_DISMISSED: 'web_native_app_promo_dismissed_permanent',
  LAST_DISMISSED_AT: 'web_native_app_promo_last_dismissed_at',
  LAST_SHOWN_AT: 'web_native_app_promo_last_shown_at',
} as const;

export const WEB_NATIVE_APP_PROMO_COPY = {
  TITLE: 'Get the Zporti app',
  MESSAGE:
    'For push alerts, smoother navigation, and the best mobile experience, install Zporti on your phone.',
  CONFIRM: 'Get the app',
  CANCEL: 'Continue on web',
  DONT_SHOW_AGAIN: "Don't show again",
} as const;

/** Sign-in uses MONKEY_OVERLAP 66 with transform; promo uses marginTop so overlap must compensate. */
const MASCOT_CARD_OVERLAP_BASE = 43;
const MASCOT_TRANSLATE_Y = 34;

export const WEB_NATIVE_APP_PROMO_MASCOT_LAYOUT = {
  WIDTH: 178,
  HEIGHT: 162,
  CARD_OVERLAP_BASE: MASCOT_CARD_OVERLAP_BASE,
  /** Nudges mascot down onto the card rim (sign-in 10 + 24px lower). */
  TRANSLATE_Y: MASCOT_TRANSLATE_Y,
  /** Base 66 + TRANSLATE_Y — marginTop grows the wrap; extra pull-up keeps the card under the monkey. */
  CARD_OVERLAP: MASCOT_CARD_OVERLAP_BASE + MASCOT_TRANSLATE_Y,
  /** Room above title on card bg only — monkey must not cover headline. */
  TITLE_TOP_SPACER_HEIGHT: 24,
} as const;

export const WEB_NATIVE_APP_PROMO_TEST_IDS = {
  TITLE_TOP_SPACER: 'web-native-app-promo-title-spacer',
  MASCOT: 'web-native-app-promo-mascot',
  CHECKBOX: 'web-native-app-promo-checkbox',
  GET_APP: 'web-native-app-promo-get-app',
  CONTINUE_WEB: 'web-native-app-promo-continue-web',
} as const;
